<template>
  <div>
    <div class="idea-list">
      <masonry class="masonry-list" :cols="{default: 2, 900: 1}" :gutter="16">
        <idea-item v-for="(idea, index) in ideas" v-bind:idea="ideas[index]" :id="idea.id" v-bind:key="index"></idea-item>
      </masonry>
    </div>
  </div>
</template>

<script>
import IdeaItem from "./IdeaItem.vue";

export default {
  components: {
    IdeaItem
  },
  data() {
    return {
    };
  },
  computed: {
    ideas: {
      get: function() {
        return this.ideaList;
      },
      set: function(value) {
        this.$emit("update:ideaList", value);
      }
    }
  },
  methods: {
  },
  props: {
    ideaList: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
.idea-list {
  margin-bottom: 60px;
}

.idea-list .idea-item {
  margin: auto;
  margin-bottom: 10px;
  padding: 0;
}
</style>